import ModalShell from './ModalShell';

// ─── ONE-OFF DATE NOTICE (21-10-2026 Vijayadashami road closure) ──────────────
// Hardcoded, date-keyed, single-day. Shown once per session when a guest or a
// partner selects this exact ISO date on the date-selection screen. It expires
// on its own: once the 21st has passed the date can no longer be selected.
// To remove later: delete this file and the two call sites in SelectDate.js and
// partner/PartnerSelectDate.js.
export const DATE_NOTICE = {
  date: '2026-10-21', // exact card ISO (YYYY-MM-DD) — no other date triggers it
  heading: 'Getting to the boat on 21 October',
  paragraphs: [
    'Vijayadashami immersions will close MG Road along the river for most of the day.',
    'Come via Panbazar road instead. Vehicles can reach the junction near City Pharmacy, and from there it is about a 1 km walk to the Gateway of Guwahati Terminal.',
    'Parking in Panbazar is limited and we cannot hold a space for you, so we would suggest taking a cab to the junction rather than driving.',
    'Please allow extra time.',
  ],
  mapLabel: 'See the junction on the map',
  mapUrl: 'https://maps.app.goo.gl/suunJjDGmma7Cc8D6',
  primaryLabel: 'Got it, continue',
  secondaryLabel: 'Choose another date',
};

const SESSION_KEY = `ag_date_notice_${DATE_NOTICE.date}`;

// True exactly once per session for the notice date; false for every other
// date. If sessionStorage throws (private mode, blocked storage), the notice is
// shown again — a repeat is better than a miss.
export function shouldShowDateNotice(iso) {
  if (iso !== DATE_NOTICE.date) return false;
  try {
    if (window.sessionStorage.getItem(SESSION_KEY) === '1') return false;
    window.sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    // Storage unavailable: fall through and show.
  }
  return true;
}

// The modal itself. Matches the hold-confirmation modal (ModalShell chrome,
// diamond rule, cormorant heading, gold primary). Never blocks continuing:
// onContinue acknowledges and proceeds, onChooseAnother clears the date.
export default function DateNoticeModal({ onContinue, onChooseAnother }) {
  return (
    <ModalShell ariaLabel={DATE_NOTICE.heading} onClose={onContinue}>
      {/* Ornamental diamond rule */}
      <div className="flex items-center gap-3 mb-4 w-full max-w-[180px]">
        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-[rgba(212,168,67,0.4)]" />
        <div className="w-1.5 h-1.5 rotate-45 bg-[rgba(212,168,67,0.55)] shrink-0" />
        <div className="flex-1 h-px bg-gradient-to-l from-transparent to-[rgba(212,168,67,0.4)]" />
      </div>

      <h2 className="font-cormorant font-normal text-[1.8rem] leading-[1.1] tracking-[-0.01em] text-white mb-3">
        {DATE_NOTICE.heading}
      </h2>

      <div className="flex flex-col gap-3 mb-4">
        {DATE_NOTICE.paragraphs.map((text) => (
          <p key={text} className="font-dm-sans text-sm font-light text-white/60 leading-relaxed">
            {text}
          </p>
        ))}
      </div>

      <a
        href={DATE_NOTICE.mapUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block font-dm-sans text-[13px] font-medium text-[#D4A843] hover:text-[#C9A84C] underline-offset-2 hover:underline transition-colors duration-200 mb-6"
      >
        {DATE_NOTICE.mapLabel} &rarr;
      </a>

      <div className="flex flex-col gap-3">
        <button
          type="button"
          onClick={onContinue}
          className="w-full py-[14px] bg-[#C9A84C] text-[#0A1628] font-dm-sans font-semibold text-[12.5px] tracking-[0.15em] uppercase rounded-full transition-[transform,background-color] duration-[160ms] ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97] hover:bg-[#B8973E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(201,168,76,0.5)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D1E35]"
        >
          {DATE_NOTICE.primaryLabel}
        </button>
        <button
          type="button"
          onClick={onChooseAnother}
          className="w-full py-1 font-dm-sans text-[13px] font-medium text-white/60 hover:text-white/90 hover:underline underline-offset-2 transition-colors duration-200"
        >
          {DATE_NOTICE.secondaryLabel}
        </button>
      </div>
    </ModalShell>
  );
}
